import { useParams } from 'react-router-dom';
import { useState } from 'react';
import { Centered } from './NotFound.jsx';

export function Completed() {
  const { token } = useParams();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  async function handleDownload() {
    setError(null);
    setBusy(true);
    try {
      const res = await fetch(`/api/m/${token}/pdf`);
      if (!res.ok) {
        if (res.status === 404) {
          setError('Your signed PDF is still being generated. Try again in a few seconds.');
        } else {
          setError('Could not retrieve the PDF. Please try again.');
        }
        return;
      }
      const data = await res.json();
      if (data.url) {
        window.location.href = data.url;
      } else {
        setError('Could not retrieve the PDF. Please try again.');
      }
    } catch {
      setError('Could not retrieve the PDF. Please try again.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <Centered title="Application submitted">
      <p>Thank you. Your Fundmerica application has been submitted and signed.</p>
      <p>A copy of your signed application will be emailed to you shortly.</p>
      <button onClick={handleDownload} disabled={busy} className="btn-primary mt-4 inline-block">
        {busy ? 'Loading…' : 'Download signed PDF'}
      </button>
      {error && <p className="text-red-600 mt-2 text-sm">{error}</p>}
    </Centered>
  );
}
